import { ref, remove, get, update } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetExpenseDataFirebase from "./GetExpenseDataFirebase";

const DeleteExpenseDataInFirebase = async (state, dispatch, uniqueID, userId) => {

    const USERID = userId ? userId : state?.USERID

    console.log("userid", USERID);
    console.log("uniqueID", uniqueID);

    if (!USERID) return null;

    try {

        // Reference to the specific invoice in Firebase
        const userRef = ref(database, `invoiceGenerator/users/${USERID}/expense/${uniqueID}`);

        const snapshot = await get(userRef);
        if (!snapshot.exists()) {
            return { success: false, message: "Expense not found." };
        }

        // Instead of deleting, just mark as deleted
        await update(userRef, { isDeleted: true,
            deletedBy: state?.USERID || "guest" });


        // Fetch updated invoice data after deletion
        await GetExpenseDataFirebase(state, dispatch);

        return { success: true, message: "Expense deleted successfully!" };
    } catch (error) {
        return { success: false, message: error.message || "Failed to delete expense." };
    }
};

export default DeleteExpenseDataInFirebase;
